module.exports = __webpack_public_path__ + "media/images/bank_images/bva-6cd3a62a71917174701b112b4c65e21d.png";